module.exports = __webpack_public_path__ + "static/jamiejones_1-7161ef4f2e06e6aa6f2bb0654089e331.jpg";